import { useCallback } from 'react';
import { useKeepStateContext } from '~/contexts/KeepStateContext.tsx';

type Dispatch<A> = (value: A) => void;
type StateSetter<S> = (prevState: S) => S;
type SetStateAction<S> = S | StateSetter<S>;

export function useKeepState<S>(key: string, initialState: S): [S, Dispatch<SetStateAction<S>>] {
  const keepStateContext = useKeepStateContext();
  if (keepStateContext === null) throw new Error('KeepState is not initialized');

  const [_get, _set] = keepStateContext;
  const setter: Dispatch<SetStateAction<S>> = useCallback(
    (s: SetStateAction<S>) => {
      _set(key, s);
    },
    [key, _set]
  );
  const value = (_get(key, initialState) as S) ?? initialState;
  return [value, setter];
}
